import { advancedFlowSchema_ } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Editor-state fetch for the processing-flow editor (Compensation / Restocking).
 * Returns one AdvancedFlow doc per versionGroup on the team for the requested
 * schema type — the one the editor should render and edit. Selection order
 * (per versionGroup):
 *
 *   1. The draft revision (publishedAt: null) if one exists.
 *   2. The most recently published revision.
 *   3. The legacy pre-versioning doc (no `flowRevisionId`).
 *
 * `draftFlowRevisionId` is the shared id across phases of the current draft
 * (undefined when no draft exists); the editor passes it back on subsequent
 * Save calls so successive edits update the same draft instead of stacking.
 *
 * `lastPublishedAt` is the most recent `publishedAt` across the team's
 * published docs of this schema type, used by the editor header's
 * "Last published …" label.
 */
export const getProcessingFlowEditorState = {
  name: "getProcessingFlowEditorState" as const,
  input: z.object({ schemaType: createEnum(SchemaType) }),
  output: z.object({
    perPhase: z.array(advancedFlowSchema_),
    draftFlowRevisionId: z.string().optional(),
    lastPublishedAt: z.date().optional(),
  }),
};
